var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M579.8 267.7A144.6 144.6 0 0 0 393.5 47.8l-1.6 1.1a32 32 0 1 0 37.2 52l1.6-1.1a80.5 80.5 0 0 1 103.8 122.6L422.3 334.8A80.6 80.6 0 0 1 299.7 231l1.1-1.6a32 32 0 0 0-52-37.2l-1.1 1.6A144.6 144.6 0 0 0 467.5 380l112.3-112.3zM60.2 244.3a144.6 144.6 0 0 0 186.3 219.9l1.6-1.1a32 32 0 1 0-37.2-52l-1.6 1.1a80.7 80.7 0 0 1-103.8-122.7l112.2-112.3a80.6 80.6 0 0 1 122.6 103.9l-1.1 1.6a32 32 0 0 0 52 37.2l1.1-1.6A144.4 144.4 0 0 0 172.5 132L60.2 244.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.e871453f0d5db7c71d7f9d251dc82977.svg";
export { ForwardRef as ReactComponent };